import { Footer, Header } from "./components";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop";
import { Helmet } from "react-helmet";

function App() {
  const robotsMeta = process.env.REACT_APP_ROBOTS || "noindex,nofollow";
  const {pathname} = useLocation();

  return (
    <>
      <Helmet>
        <meta name="robots" content={robotsMeta} />
      </Helmet>

      <div className="flex flex-col justify-between min-h-screen">
        <Header />
        <main className="pt-[80px] md:pt-[136px] overflow-hidden">
          <div className={pathname!=="/" ? "gradient-effect" : ""}></div>
          <ScrollToTop />
          <Outlet />
        </main>
        <Footer />
        <ToastContainer autoClose={4000} hideProgressBar pauseOnHover />
      </div>
    </>
  );
}

export default App;
